import { defineMessages } from 'react-intl';

export default defineMessages({
  'heading': {
    'id': 'product_matches.heading',
    'defaultMessage': 'Product Matches',
    'description': 'Product matches page heading and title'
  },
  'intro': {
    'id': 'product_matches.intro',
    'defaultMessage': 'Ret\u00FCl technology leverages your body data and riding preferences to match you with Specialized products that fit you best.',
    'description': 'Product matches page heading intro'
  },
  'load_error': {
    'id': 'product_matches.load_error',
    'defaultMessage': 'We are unable to retrieve your Product Matches at this time, please try again later.',
    'description': 'Product matches page general loading error'
  },
  'product_type_filter_label': {
    'id': 'product_matches.product_type_filter_label',
    'defaultMessage': 'Product Type',
    'description': 'Product matches page product types drop down filter label'
  },
  'product_type_filter_bikes_label': {
    'id': 'product_matches.product_type_filter_bikes_label',
    'defaultMessage': 'Bikes',
    'description': 'Product matches page product types drop down bikes option label'
  },
  'product_type_filter_saddles_label': {
    'id': 'product_matches.product_type_filter_saddles_label',
    'defaultMessage': 'Saddles',
    'description': 'Product matches page product types drop down saddles option label'
  },
  'product_type_filter_shoes_label': {
    'id': 'product_matches.product_type_filter_shoes_label',
    'defaultMessage': 'Shoes',
    'description': 'Product matches page product types drop down shoes option label'
  },
  'category_filter_label': {
    'id': 'product_matches.category_filter_label',
    'defaultMessage': 'Category',
    'description': 'Product matches page category drop down filter label'
  },
  'category_filter_road_label': {
    'id': 'product_matches.category_filter_label_road',
    'defaultMessage': 'Road',
    'description': 'Product matches page category drop down filter road option label'
  },
  'category_filter_mountain_xc_label': {
    'id': 'product_matches.category_filter_mountain_xc_label',
    'defaultMessage': 'Mountain (cross country)',
    'description': 'Product matches page category drop down filter mountain cross country option label'
  },
  'category_filter_mountain_trail_label': {
    'id': 'product_matches.category_filter_mountain_trail_label',
    'defaultMessage': 'Mountain (trail)',
    'description': 'Product matches page category drop down filter mountain trail option label'
  },
  'category_filter_triathlon_label': {
    'id': 'product_matches.category_filter_triathlon_label',
    'defaultMessage': 'Triathlon',
    'description': 'Product matches page category drop down filter triathlon option label'
  },
  'category_filter_cyclocross_label': {
    'id': 'product_matches.category_filter_cyclocross_label',
    'defaultMessage': 'Cyclocross',
    'description': 'Product matches page category drop down filter cyclocross option label'
  },
  'category_filter_commute_sport_label': {
    'id': 'product_matches.category_filter_commute_sport_label',
    'defaultMessage': 'Commute-sport',
    'description': 'Product matches page category drop down filter commute sport option label'
  },
  'category_filter_commute_comfort_label': {
    'id': 'product_matches.category_filter_commute_comfort_label',
    'defaultMessage': 'Commute-comfort',
    'description': 'Product matches page category drop down filter commute comfort option label'
  },
  'gender_filter_all_label': {
    'id': 'product_matches.gender_filter_all_label',
    'defaultMessage': 'Show all product',
    'description': 'Product matches page gender drop down filter all option label'
  },
  'gender_filter_male_label': {
    'id': 'product_matches.gender_filter_male_label',
    'defaultMessage': 'Show men\'s product',
    'description': 'Product matches page gender drop down filter male option label'
  },
  'gender_filter_female_label': {
    'id': 'product_matches.gender_filter_female_label',
    'defaultMessage': 'Show women\'s product',
    'description': 'Product matches page gender drop down filter female option label'
  },
  'last_session_match_label': {
    'id': 'product_matches.last_session_match_label',
    'defaultMessage': 'Last Match Session',
    'description': 'Product matches session area last session match label'
  },
  'empty_session': {
    'id': 'product_matches.empty_session',
    'defaultMessage': 'We don’t have body data to provide you with Match results for this product type. Use the filter above to see other product types, or use the locations page to find a location to complete this Match module.',
    'description': 'Product matches empty session text'
  },
  'find_retul_technology_label': {
    'id': 'product_matches.find_retul_technology_label',
    'defaultMessage': 'Find Retul Technology',
    'description': 'Product matches find retul technology button text'
  },
  'recommended_label': {
    'id': 'product_matches.recommended_label',
    'defaultMessage': 'Recommended',
    'description': 'Product matches session area recommended label'
  },
  'starting_label': {
    'id': 'product_matches.starting_label',
    'defaultMessage': 'Starting',
    'description': 'Product matches session area starting label'
  },
  'bike_size_label': {
    'id': 'product_matches.bike_size_label',
    'defaultMessage': 'bike size',
    'description': 'Product matches session area bike size label'
  },
  'saddle_height_label': {
    'id': 'product_matches.saddle_height_label',
    'defaultMessage': 'saddle height',
    'description': 'Product matches session area saddle height label'
  },
  'saddle_size_label': {
    'id': 'product_matches.saddle_size_label',
    'defaultMessage': 'saddle size',
    'description': 'Product matches session area saddle size label'
  },
  'shoe_size_label': {
    'id': 'product_matches.shoe_size_label',
    'defaultMessage': 'shoe size',
    'description': 'Product matches session area shoe size label'
  },
  'millimeter_symbol': {
    'id': 'product_matches.millimeter_symbol',
    'defaultMessage': 'mm',
    'description': 'Product matches session area millimeter symbol'
  },
  'centimeter_symbol': {
    'id': 'product_matches.centimeter_symbol',
    'defaultMessage': 'cm',
    'description': 'Product matches session area centimeter symbol'
  },
  'view_on_specialized_label': {
    'id': 'product_matches.view_on_specialized_label',
    'defaultMessage': 'View on Specialized',
    'description': 'Product match view on specialized button text'
  },
  'padding_level_label': {
    'id': 'product_matches.padding_level_label',
    'defaultMessage': 'Padding Level',
    'description': 'Saddle product match padding level label'
  },
  'saddle_models_label': {
    'id': 'product_matches.saddle_models_label',
    'defaultMessage': 'Models',
    'description': 'Saddle product match models listing label'
  },
  'saddle_detail_size_label': {
    'id': 'product_matches.saddle_detail_size_label',
    'defaultMessage': 'Saddle Size:',
    'description': 'Saddle product match models listing label'
  },
  'overlay_bike_size_label': {
    'id': 'product_matches.overlay_bike_size_label',
    'defaultMessage': 'bike size',
    'description': 'Bike session overlay heading label'
  },
  'overlay_bike_size_details': {
    'id': 'product_matches.overlay_bike_size_details',
    'defaultMessage': 'From the biometrics captured during your Retül Match session, we recommend the above bike size. While this is a good starting point, we still advise that you consult with your local retailer for recommendations based on your experience level and body type.',
    'description': 'Bike session overlay details text'
  },
  'overlay_saddle_height_label': {
    'id': 'product_matches.overlay_saddle_height_label',
    'defaultMessage': 'saddle height',
    'description': 'Saddle height session overlay heading label'
  },
  'overlay_saddle_height_details': {
    'id': 'product_matches.overlay_saddle_height_details',
    'defaultMessage': 'From the biometrics captured during your Retül Match session, we recommend the above saddle height. While this is a good starting point, we still advise that you consult with your local retailer for recommendations based on your experience level and body type.',
    'description': 'Saddle height session overlay details text'
  },
  'overlay_saddle_size_label': {
    'id': 'product_matches.overlay_saddle_size_label',
    'defaultMessage': 'saddle size',
    'description': 'Saddle size session overlay heading label'
  },
  'overlay_saddle_size_details': {
    'id': 'product_matches.overlay_saddle_size_details',
    'defaultMessage': 'From the biometrics captured during your Retül Match session, we recommend the above saddle size. While this is a good starting point, we still advise that you consult with your local retailer for recommendations based on your body specifics.',
    'description': 'Saddle size session overlay details text'
  },
  'overlay_shoe_size_label': {
    'id': 'product_matches.overlay_shoe_size_label',
    'defaultMessage': 'shoe size',
    'description': 'Shoe size session overlay heading label'
  },
  'overlay_shoe_size_details': {
    'id': 'product_matches.overlay_shoe_size_details',
    'defaultMessage': 'From the biometrics captured during your Retül Match session, we recommend the above shoe size. While this is a good starting point, we still advise that you consult with your local retailer for recommendations based on your experience level.',
    'description': 'Shoe size session overlay details text'
  },
  'overlay_close_label': {
    'id': 'product_matches.overlay_close_label',
    'defaultMessage': 'Close',
    'description': 'Session overlay close button text'
  },
  'overlay_indicator_label': {
    'id': 'product_matches.overlay_indicator_label',
    'defaultMessage': 'You',
    'description': 'Session overlay close button text'
  }
});



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/messages.js